import React from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";

export default class SelectOptions extends React.Component {
  static get propTypes() {
    return {
      defaultValue: PropTypes.string,
      displayText: PropTypes.string,
      noDisplayText: PropTypes.bool,
      items: PropTypes.oneOfType([
        PropTypes.instanceOf(Immutable.List),
        PropTypes.instanceOf(Immutable.Iterable),
        PropTypes.array,
      ]).isRequired,
      selectItemAction: PropTypes.func,
      selected: PropTypes.string,
    };
  }

  constructor(props, context) {
    super(props, context);

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(e) {
    const { selectItemAction } = this.props;

    selectItemAction(e.target.value);
  }

  renderCategories() {
    const { items, displayText, defaultValue = "", noDisplayText } = this.props;

    const opts = items.map((item, idx) => {
      return (
        <option key={idx} value={item}>
          {item}
        </option>
      );
    });

    if (noDisplayText === true) {
      return opts;
    } else {
      return [
        <option key={items.count()} value={defaultValue}>
          {displayText}
        </option>,
      ].concat(opts);
    }
  }

  render() {
    const { selected = "", defaultValue = "" } = this.props;

    return (
      <select
        id="campaignSelect"
        className="campaign-tile-search"
        value={selected || defaultValue}
        onChange={this.handleSelect}>
        {this.renderCategories()}
      </select>
    );
  }
}
